import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { setResponseErrorShow } from '../../../store/reducers/app/ResponseInfoSlices'
import ResponseError from './ResponseError'

let ResponseErrorContainer = () => {

    const dispatch = useAppDispatch()

    const error = useAppSelector<number | null>(state => state.responseInfo.error)
    const errorShow = useAppSelector<boolean>(state => state.responseInfo.errorShow)

    
    useEffect(
        () => {
            if(errorShow){
                setTimeout(() => {
                    dispatch(setResponseErrorShow(false))
                }, 3000)
            }
        }, [dispatch, errorShow]
    )

    return (
        <>
            {errorShow
                ?
                    <ResponseError
                        error={error}
                    />
                : null
            }
        </>
    )
}

export default ResponseErrorContainer